/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import {
  Modal, WingBlank, Toast, List, Checkbox, Radio, DatePicker,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import styles from './styles.module.less';
import closeImage from '../../orderConfirm/img/manage-close.png';
import SendVRCode from '../../../components/sendVRCode';
import { getSignUpPage, getSignUp } from '../../../service/chat-service';

const { RadioItem } = Radio;
const { CheckboxItem } = Checkbox;

const propTypes = {
  onClose: PropTypes.func,
  liveDetail: PropTypes.shape({
    streamName: PropTypes.string,
    liveStart: PropTypes.string,
  }),
  isRecord: PropTypes.bool,
  shareUserId: PropTypes.string,
  shareOpenId: PropTypes.string,
  Id: PropTypes.number,
  liveType: PropTypes.number,
  history: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  onClose: () => {},
  liveDetail: {},
  isRecord: false,
  shareUserId: '',
  Id: 0,
  liveType: 0,
  history: [],
  shareOpenId: '',
};

/**
 * 报名
 */
class SigUpModal extends Component {
  constructor() {
    super();
    this.state = {
      bmList: [],
      liveId: null,
      // bmCount: 0,
      liveInfo: {},
      value: '',
    };
  }

  componentDidMount() {
    this.loadData();
  }

  /**
   * 获取报名基本信息
   * @returns {Promise<void>}
   */
  loadData = async () => {
    const { Id } = this.props;
    const params = { id: Id };
    try {
      const { data } = await getSignUpPage(params);
      const list = data.bmList;
      list.forEach((item) => {
        item.value = '';
      });
      this.setState({
        bmList: list,
        liveId: data.liveId,
        // bmCount: data.bmCount
      });
    } catch (e) {
      // console.log(e);
    }
  }

  handleChangeClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  handleChange = (key) => (event) => {
    const { value } = event.target;
    const { liveInfo } = this.state;
    liveInfo[key] = value;
    this.setState({ ...liveInfo });
  }

  handleChangeClick = () => {
    const {
      liveId, liveInfo, bmList,
    } = this.state;
    console.log(liveId);
    const {
      liveDetail, onClose, isRecord, shareUserId, Id, liveType, history, shareOpenId,
    } = this.props;
    if (!liveInfo.wxName) return Toast.show('请输入昵称');
    if (!liveInfo.mobile) return Toast.show('请输入手机号');
    if (liveInfo.mobile.length !== 11) return Toast.show('请检查手机号输入格式');
    if (!liveInfo.code) return Toast.show('请输入验证码');
    const data = {
      id: Id,
      shareOpenId,
      openId: localStorage.getItem('openId') || '',
      shareUserId: shareUserId || '',
      bmList: JSON.stringify(bmList),
    };
    const params = { ...data, ...liveInfo };
    getSignUp(params)
      .then((res) => {
        if (res.code === 10000) {
          if (liveType === 1) {
            // 正在直播 开启报名报名成功后 跳转到直播页面
            history.push(
              `/liveRegistration?
            streamName=${liveDetail.streamName}
            &liveId=${Id}&isRecord=${isRecord}&shareUserId=${shareUserId}`,
            );
          } else if (liveType === 0) {
            Toast.show('报名成功'); // 直播未开始 后台开启报名 报名成功后关闭弹框
            onClose(true, '报名成功');
          }
        } else {
          Toast.show(res.message || '报名失败');
        }
      })
      .catch(() => {
        // console.log(error)
      });
    return true;
  }

  bmListTypes=() => {
    const { bmList } = this.state;
    return bmList.map((item) => (
      this.textSwitch(item)
    ));
  }

  // 文本。数值
  textSwitchChange = (key, type) => (event) => {
    const { value } = event.target;
    const { bmList } = this.state;
    if (type === 1 && !Number(value)) {
      Toast.show('请输入数字');
    }
    bmList.map((item) => {
      if (item.fieldId === key) {
        item.value = value;
      }
    });
    this.setState({ bmList });
  }

  /**
   * 解决ios软键盘空白隐藏出现空白问题
   */
  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  }

  // 多选
  onChangeCheckbox=(key, val) => {
    const { bmList } = this.state;
    bmList.map((item) => {
      if (item.fieldId === key) {
        const { value } = item;
        if (value === '') {
          const arr = [];
          arr.push(`${val}`);
          item.value = arr;
        } else {
          let aa = value.toString();
          if (aa.indexOf(`${val}`) !== -1) {
            aa = aa.replace(`${val}`, '');
          } else {
            aa += `,${val}`;
          }
          item.value = aa.split(',');
        }
      }
    });
    this.setState(bmList);
  }

  // 单选
onChangeRadio=(key, val) => {
  const { bmList } = this.state;
  bmList.map((item) => {
    if (item.fieldId === key) {
      item.value = val;
    }
  });
  this.setState(bmList);
}

// 日期
onChangeDatePicker=(key, val) => {
  const { bmList } = this.state;
  bmList.map((item) => {
    if (item.fieldId === key) {
      item.value = format(new Date(val), 'yyyy-MM-dd');
    }
  });
  this.setState(bmList);
}

  // 自定义表单  fieldType字段类型 0文本 1数值 2单选 3多选 4时间
  textSwitch = (task) => {
    switch (task.fieldType) {
      case 0:
      case 1:
        return (
          <div className={styles.inputBox}>
            <input
              maxLength={11}
              type="text"
              onBlur={this.scrollPosition}
              placeholder={task.fieldName}
              onChange={this.textSwitchChange(task.fieldId, task.fieldType)}
              // value={liveInfo.name}
            />
          </div>
        );
      case 2:
        return (
          <List renderHeader={task.fieldName}>
            {task.customFieldOptionModels.map((i) => (
              <RadioItem
                key={i.id}
                onBlur={this.scrollPosition}
                checked={task.value === i.optionName}
                onChange={() => this.onChangeRadio(task.fieldId, i.optionName)}
              >
                {i.optionName}
              </RadioItem>
            ))}
          </List>
        );
      case 3:
        return (
          <List renderHeader={task.fieldName}>
            {task.customFieldOptionModels.map((i) => (
              <CheckboxItem
                key={i.id}
                onBlur={this.scrollPosition}
                onChange={() => this.onChangeCheckbox(task.fieldId, i.optionName)}
              >
                {i.optionName}
              </CheckboxItem>
            ))}
          </List>
        );
      case 4:
        return (
          <List className="date-picker-list" style={{ backgroundColor: 'white' }}>
            <DatePicker
              onBlur={this.scrollPosition}
              mode="date"
              title="Select Date"
              format="YYYY-MM-DD"
              value={task.value ? new Date(task.value) : undefined}
              onChange={(date) => this.onChangeDatePicker(task.fieldId, date)}
            >
              <List.Item arrow="horizontal">{task.fieldName}</List.Item>
            </DatePicker>
          </List>
        );
      default:
        return '';
    }
  }

  render() {
    const { liveInfo, value } = this.state;
    console.log(value);
    return (
      <Modal
        popup
        visible
        animationType="slide-up"
        className={styles.modalContentRadius}
        maskClosable
        onClose={this.handleChangeClose}
      >
        <div className={styles.invoiceContent}>
          <div className={styles.headers}>
            <p className={styles.headerFont}>报名活动</p>
            <span className={styles.close} onClick={this.handleChangeClose} role="button" tabIndex="0">
              <img src={closeImage} alt="closeImage" />
            </span>
          </div>
          <WingBlank>
            <div className={styles.contentBox}>
              <div className={styles.inputBox}>
                <input
                  maxLength={11}
                  type="text"
                  onBlur={this.scrollPosition}
                  placeholder="昵称"
                  onChange={this.handleChange('wxName')}
                  value={liveInfo.name}
                />
              </div>
              <div className={styles.inputBox}>
                <input
                  maxLength={11}
                  type="text"
                  onBlur={this.scrollPosition}
                  placeholder="请输入手机号"
                  onChange={this.handleChange('mobile')}
                  value={liveInfo.mobile}
                />
              </div>
              <div className={styles.inputBox}>
                <input
                  type="text"
                  maxLength={6}
                  placeholder="验证码"
                  onBlur={this.scrollPosition}
                  onChange={this.handleChange('code')}
                  value={liveInfo.code}
                />
                <div className={styles.right}>
                  <SendVRCode type="live" phoneNumber={liveInfo.mobile} className={styles.sendCode} />
                </div>
              </div>
              {this.bmListTypes()}
              <div className={styles.buttonok} onClick={this.handleChangeClick} role="button" tabIndex="0">
                确认报名
              </div>
            </div>
          </WingBlank>
        </div>
      </Modal>
    );
  }
}

SigUpModal.propTypes = propTypes;
SigUpModal.defaultProps = defaultProps;

export default SigUpModal;
